/** A sentence with the first occurrence of `word` made a glossary `Term` (UD-18). Text nodes only; the sentence is not reworded. */
import type { JSX } from 'preact';
import { CHANNEL_IDS, type ChannelId } from '../../engine/channels/types.ts';
import type { GlossaryKey } from '../../shared/help-types.ts';
import { ChannelTerm, Term } from '../components/Term.tsx';

export function TermIn({
	text,
	word,
	k,
}: { text: string; word: string; k: GlossaryKey }): JSX.Element {
	const i = text.toLowerCase().indexOf(word.toLowerCase());
	if (i < 0) return <>{text}</>;
	return (
		<>
			{text.slice(0, i)}
			<Term k={k}>{text.slice(i, i + word.length)}</Term>
			{text.slice(i + word.length)}
		</>
	);
}

const ID_RE = new RegExp(
	`\\b(${[...CHANNEL_IDS].sort((a, b) => b.length - a.length).join('|')})\\b`,
	'g'
);
const ID_SET: ReadonlySet<string> = new Set(CHANNEL_IDS);

/** Text with every channel ID in it made a `ChannelTerm` (the explainer popover); other text stays as it is (UD-20). */
export function ChannelIdsIn({ text }: { text: string }): JSX.Element {
	const parts = text.split(ID_RE);
	if (parts.length === 1) return <>{text}</>;
	return (
		<>
			{parts.map((p, i) =>
				ID_SET.has(p) ? (
					// biome-ignore lint/suspicious/noArrayIndexKey: the same ID can occur twice in one line
					<ChannelTerm key={i} id={p as ChannelId} />
				) : (
					p
				)
			)}
		</>
	);
}
